<app-spinner-overlay></app-spinner-overlay>

<form [formGroup]="formCreaCfgQuestionario">
  <div class="top-container">
    <div appFormContainer [larghezza]="6" class="campi" [alignItems]="'flex-start'">
      <mat-form-field appFormElement [larghezza]="2" class="input-form" *ngIf="!nascondiTitolo">
        <mat-label>Titolo</mat-label>
        <input matInput placeholder="Titolo" formControlName="titolo" />
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <div
        appFormElement
        [larghezza]="2"
        *ngIf="tipoQuestionario === 'AUTOVALUTAZIONE'"
        style="display: flex; flex-direction: column; justify-content: center; align-items: center"
        [riempi]="true"
      >
        <mat-label style="padding-left: 20px">Tipo assessment</mat-label>
        <div class="cnt-radio-specific">
          <mat-radio-group
            aria-label="Select an option"
            formControlName="tipoAutovalutazione"
            style="padding-left: 10px; display: flex; column-gap: 10px"
            (change)="onSelectionChangeTipo($event)"
          >
            <mat-radio-button aria-label="Sito vetrina" value="GENERICO"
              >Sito vetrina</mat-radio-button
            >
            <mat-radio-button aria-label="Per settore" value="SETTORE"
              >Per settore</mat-radio-button
            >
          </mat-radio-group>

          <div class="slide-specific">
            <mat-slide-toggle formControlName="specificUser">Specific</mat-slide-toggle>
          </div>
        </div>
      </div>

      <div
        *ngIf="tipoQuestionario === 'AUTOVALUTAZIONE'"
        class="container-azioni"
        appFormContainer
        [larghezza]="2"
      >
        <div class="row-superiore">
          <button mat-flat-button color="accent" (click)="salvaInterno()">Salva Bozza</button>

          <button mat-flat-button color="accent" (click)="anteprimaAutovalutazione()">
            Anteprima
          </button>
        </div>

        <button
          mat-flat-button
          color="primary"
          class="btn-pubblica"
          (click)="pubblicaAutovalutazione()"
        >
          Pubblica
        </button>
      </div>

      <mat-form-field
        appFormElement
        [larghezza]="2"
        class="input-form"
        *ngIf="
          tipoQuestionario === 'SURVEY' ||
          formCreaCfgQuestionario.get('tipoAutovalutazione')?.value === 'SETTORE'
        "
      >
        <mat-label>Settori*</mat-label>
        <mat-select
          formControlName="settori"
          placeholder="Settori"
          [compareWith]="compareById"
          (selectionChange)="onSelectionChangeSettore($event)"
        >
          <mat-option *ngFor="let set of arraySettori" [value]="set">{{ set.titolo }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        appFormElement
        [larghezza]="2"
        class="input-form"
        *ngIf="
          (tipoQuestionario === 'SURVEY' ||
            formCreaCfgQuestionario.get('tipoAutovalutazione')?.value === 'SETTORE') &&
          arraySottoSettori?.length
        "
      >
        <mat-label>Sotto-settori</mat-label>
        <mat-select
          formControlName="sottoSettori"
          placeholder="Sotto-settori"
          [compareWith]="compareById"
          multiple
        >
          <mat-option *ngFor="let sottoSet of arraySottoSettori" [value]="sottoSet">{{
            sottoSet.titolo
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        *ngIf="
          this.tipoQuestionario === 'AUTOVALUTAZIONE' &&
          (this.formCreaCfgQuestionario.get('settori')?.value ||
            formCreaCfgQuestionario.get('tipoAutovalutazione')?.value === 'GENERICO')
        "
        appFormElement
        [larghezza]="2"
        class="input-form"
        [riempi]="true"
      >
        <mat-label>Ambiti</mat-label>
        <mat-select
          formControlName="ambiti"
          placeholder="Ambiti"
          multiple
          [compareWith]="compareById"
        >
          <mat-option
            *ngFor="let amb of arrayAmbiti"
            [value]="amb"
            [disabled]="ambitiLocked[amb.id]"
            >{{ amb.titoloBreve }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</form>

<ng-container *ngIf="isUtenteGo && tipoQuestionario === 'BILANCIO'">
  <div class="titolo-sezione-dialog">Scegli la tematica su cui si baserà il tuo report</div>

  <div class="descrizione-sezione-dialog">Potrai trattare un'unica tematica.</div>
</ng-container>

<!-- ═══════════════════════════════════════════════════════════
     EMPTY STATE — nessun ambito
═══════════════════════════════════════════════════════════ -->
<ng-container *ngIf="!this.ambitiSelezionati.length">
  <div class="empty-state">
    <div class="empty-state__icon-wrap">
      <mat-icon class="empty-state__icon">inbox</mat-icon>
    </div>
    <p class="empty-state__title">Nessun ambito disponibile</p>
    <p class="empty-state__subtitle">Seleziona un settore per visualizzare gli ambiti.</p>
  </div>
</ng-container>

<!-- TAB DOVE CI SONO GLI AMBITI -->
<mat-tab-group *ngIf="this.ambitiSelezionati.length">
  <ng-container *ngIf="this.ambitiSelezionati?.length">
    <!-- TAB POPOLATA DAGLI AMBITI -->
    @for (amb of ambitiSelezionati; track amb.id) {
      <!-- VISUALIZZO SOLAMENTE GLI AMBITI CHE HANNO ALMENO Q TEMATICA DISPONIBILE O SELEZIONATA  -->
      @if (arrayTematicheSel[amb.id]?.length || arrayTematicheDisponibili[amb.id]?.length) {
        <mat-tab [label]="amb.titoloBreve">
          <!-- CONTENUTO DELLA TAB -->

          <div class="tematiche" appFormContainer [larghezza]="2">
            <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
              <div class="cont-titolo">
                <mat-label class="titolo">Tematiche Selezionate</mat-label>
              </div>
              <ng-scrollbar #scrollSelezionate [id]="amb.id + '_sel'">
                <div
                  scrollViewport
                  dropListScroller
                  cdkDropList
                  #selList="cdkDropList"
                  [cdkDropListData]="arrayTematicheSel[amb.id]"
                  [cdkDropListConnectedTo]="[dispList]"
                  class="list"
                  (cdkDropListDropped)="drop($event, amb.id, 'SELEZIONATI')"
                >
                  <!-- Empty state for list -->
                  <div class="list-empty" *ngIf="!arrayTematicheSel[amb.id]?.length">
                    <mat-icon>drag_indicator</mat-icon>
                    <span>Trascina le tematiche qui</span>
                  </div>

                  <div
                    class="box"
                    *ngFor="let sel of arrayTematicheSel[amb.id]; let idx = index"
                    cdkDrag
                    [cdkDragDisabled]="qstDisabilitato || sel?.locked"
                    [matTooltip]="sel.descrizione"
                    matTooltipPosition="left"
                  >
                    <div class="box-sx">
                      <button
                        mat-icon-button
                        title="Sposta"
                        aria-label="Sposta"
                        [disabled]="qstDisabilitato || sel?.locked"
                      >
                        <mat-icon> drag_indicator </mat-icon>
                      </button>

                      @if (sel.idAzienda) {
                        <span class="badge-tematica-aziendale" matTooltip="Tematica aziendale">
                          Aziendale
                        </span>
                      }

                      <mat-label class="truncate">{{ sel.domanda }}</mat-label>
                    </div>

                    @if (tipoQuestionario === 'DOPPIA_MATERIALITA' && sel.esrs.length) {
                      <!-- Icona per mostrare se una tematica è ESRS -->
                      <mat-icon matTooltip="Tematica ESRS" color="accent"> stars </mat-icon>

                      <!-- edit ESRS -->
                      <button
                        mat-icon-button
                        class="material-icons-outlined icone-tem icone-label-chack icona-lucchetto"
                        [matTooltip]="'Modifica la selezione ESRS'"
                        (click)="$event.stopPropagation(); openSelezioneESRS(amb.id, sel, idx)"
                      >
                        <span class="material-icons-outlined"> edit </span>
                      </button>
                    }

                    <!-- CONSIGLIATO - Tematica consigliata -->
                    <button
                      mat-icon-button
                      *ngIf="isTematicaConsigliata(sel)"
                      class="material-icons-outlined icone-tem icona-consigliato"
                      [matTooltip]="'Tematica consigliata, vedi maggiori informazioni'"
                      (click)="$event.stopPropagation(); apriPopUpConsigliato(sel)"
                    >
                      <span class="material-icons-outlined"> emoji_objects </span>
                    </button>

                    <!-- BLOCCATO (lucchetto) -->
                    <button
                      mat-icon-button
                      *ngIf="isTematicLocked(sel)"
                      class="material-icons-outlined icone-tem icone-label-chack icona-lucchetto"
                      [matTooltip]="'Tematica obbligatoria, vedi maggiori informazioni'"
                      (click)="$event.stopPropagation(); apriPopUpObbligatorio(sel)"
                    >
                      <span class="material-icons-outlined"> lock </span>
                    </button>
                  </div>
                </div>
              </ng-scrollbar>
            </div>
            <div appFormElement [larghezza]="1" [riempi]="true" class="list-container">
              <div class="cont-titolo">
                <mat-label class="titolo">Tematiche Disponibili</mat-label>

                @if (!this.qstDisabilitato && this.showTematicheAziendali) {
                  <button
                    mat-flat-button
                    (click)="aggiungiTematica(amb.id)"
                    class="btn-crea-tematica"
                    matTooltip="Crea la tua tematica aziendale"
                    matTooltipPosition="right"
                  >
                    <mat-icon>add</mat-icon>
                    Crea tematica
                  </button>
                }
              </div>

              <ng-scrollbar #scrollDisponibili [id]="amb.id + '_disp'">
                <div
                  cdkDropList
                  scrollViewport
                  dropListScroller
                  #dispList="cdkDropList"
                  [cdkDropListData]="arrayTematicheDisponibili[amb.id]"
                  [cdkDropListConnectedTo]="[selList]"
                  class="list"
                  style="background-color: #f5f5f5"
                  (cdkDropListDropped)="drop($event, amb.id, 'DISPONIBILI')"
                >
                  <div class="tematica-disp" *ngIf="loadingTemDisp[amb.id]">
                    <mat-spinner style="height: 50px"></mat-spinner>
                  </div>

                  <!-- Empty -->
                  <div
                    class="list-empty list-empty--muted"
                    *ngIf="!arrayTematicheDisponibili[amb.id]?.length && !loadingTemDisp[amb.id]"
                  >
                    <mat-icon>check_circle_outline</mat-icon>
                    <span>Tutte le tematiche sono state selezionate</span>
                  </div>

                  <div
                    class="box"
                    style="background-color: #f5f5f5"
                    *ngFor="let disp of arrayTematicheDisponibili[amb.id]"
                    cdkDrag
                    [cdkDragDisabled]="qstDisabilitato"
                    [matTooltip]="disp.descrizione"
                    matTooltipPosition="left"
                  >
                    <div class="box-sx">
                      <button
                        mat-icon-button
                        title="Sposta"
                        aria-label="Sposta"
                        [disabled]="qstDisabilitato"
                      >
                        <mat-icon> drag_indicator </mat-icon>
                      </button>

                      @if (disp.idAzienda) {
                        <span class="badge-tematica-aziendale" matTooltip="Tematica aziendale">
                          Aziendale
                        </span>
                      }
                      <mat-label class="truncate">{{ disp.domanda }}</mat-label>
                    </div>

                    <!-- Icona per mostrare se una tematica è ESRS -->
                    @if (tipoQuestionario === 'DOPPIA_MATERIALITA' && disp.esrs.length) {
                      <mat-icon matTooltip="Tematica ESRS" color="accent"> stars </mat-icon>
                    }
                    <!-- Icona per mostrare se una tematica è ESRS -->
                    @if (tipoQuestionario === 'REPORT_VSME') {
                      <button
                        mat-icon-button
                        class="material-icons-outlined icone-tem icona-consigliato"
                        style="color: grey !important"
                        [matTooltip]="'Motiva l’esclusione della tematica'"
                        (click)="
                          $event.stopPropagation();
                          modificaDialogMotivazioneNonApplicabilita(disp, amb.id)
                        "
                      >
                        <span class="material-icons-outlined"> article </span>
                      </button>
                    }

                    <!-- CONSIGLIATO - Tematica consigliata -->
                    <button
                      mat-icon-button
                      *ngIf="disp?.consigliato"
                      class="material-icons-outlined icone-tem icona-consigliato"
                      [matTooltip]="'Tematica consigliata, vedi maggiori informazioni'"
                      (click)="$event.stopPropagation(); apriPopUpConsigliato(disp)"
                    >
                      <span class="material-icons-outlined"> emoji_objects </span>
                    </button>

                    <!-- Edit tematica - Tematica Aziendale -->
                    @if (!this.qstDisabilitato) {
                      <button
                        mat-icon-button
                        class="material-icons-outlined icone-tem"
                        [matTooltip]="'Modifica tematica'"
                        (click)="$event.stopPropagation(); aggiungiTematica(amb.id, disp)"
                      >
                        <span class="material-icons-outlined"> edit </span>
                      </button>
                    }
                  </div>
                </div>
              </ng-scrollbar>
            </div>
          </div>
        </mat-tab>
      }
    }
  </ng-container>
</mat-tab-group>
